<template>
    <div class="row">
      <div class="col-lg-12" style="padding: 20px">
        <div class="main-card mb-3 card" style="margin-left: 10px">
          <div class="card-body">
            <div class="tab-content">
              <div id="home">
                <h5 class="card-title">
                  2025 Summer Camp 학습 게시판
                  <div
                    class="sub_title"
                    style="
                      margin-bottom: 20px;
                      color: #333;
                      font-size: 13px;
                      border: 1px solid #ccc;
                      background: #f8f8f8;
                      height: 30px;
                      text-align: right;
                      position: absolute;
                      right: 20px;
                      top: 10px;
                      padding: 2px 10px;
                    "
                  >
                    2025 Summer Camp → 학습 게시판
                  </div>
                </h5>
  
                <query-grid :config="config" ref="qg">
                  <template #actions>
                    <router-link
                      to="/events/2025Summer/new"
                       ><button class="btn btn-danger">글쓰기</button></router-link
                    >
                  </template>
                  <template #resultactions=""
                    ><!--추후 제공예정-->
  
                    <div style="text-align: right">
                      <router-link to="/events/2025_Summer"
                        ><button class="btn btn-secondary">
                          신청목록
                        </button></router-link
                      >
                      <router-link to="/events/2025_Summer_view"
                        ><button class="btn btn-secondary">
                          학습현황
                        </button></router-link
                      >
                      
                    </div>
                  </template>
                  <template #items="props">
                    <tr v-for="article in props.records" v-bind:key="article.id">
                      <td style="height: 48px">{{ article.s_int }}</td>
                      <td>{{ article.addi_data1 }}</td>
                      <td>
                        <router-link                          
                          :to="{path:'/events/'+ article.boardname +'/'+ article.id , params: { board: article.boardname , article:article.id }}"
                          >{{ article.title }}</router-link
                        >
  
                      </td>
                      <td>{{ article.writerid }}</td>
                      <td>{{ article.writerName }}</td>
                      <td>{{ article.addi_data2 }}</td>
                      <td>{{ article.created_at }}</td>
                    </tr>
                  </template>
                </query-grid>
                <div style="float: right">
                  <router-link
                      to="/events/2025Summer/new" ><button class="btn btn-danger">글쓰기</button></router-link
                    >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import axios from "axios";
  import QueryGrid from "../components/QueryGrid.vue";
  export default {
    components: {
      QueryGrid,
    },
    data: () => ({
      boards: {},
      etc: {
        board: {
          title: "",
        },
      },
      articles: [],
      selBoard: "",
      search: "",
      config: {
        name: "학습후기",
        req_endpoint: "",
        default_limit: 20,
        no_excel: true,
        search_fields: [
        {
            id: "board_type_filter",
            name: "말머리",
            type: "switch",
            filter_type: {
              '학습일기': "학습일기",
              '미션과제': "미션과제",
              '공지사항': "공지사항",
              },
          },
          {
            id: "date_filter",
            name: "날짜검색",
            type: "date",
            filter_type: {
              created_at: "등록일",
              datStudy: "학습일",
            },
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "제목/아이디/이름",
          },
        ],
        columns: [
          {
            id: "id",
            sortable: true,
            name: "번호",
            excel_print: (v) => {
              return v.id;
            },
          },
          {
            id: "addi_data1",
            sortable: true,
            name: "말머리",
            excel_print: (v) => {
              return v.addi_data1;
            },
          },
          {
            id: "title",
            sortable: true,
            name: "제목",
            excel_print: (v) => {
              return v.title;
            },
          },
          {
            id: "writerid",
            sortable: true,
            name: "아이디",
            excel_print: (v) => {
              return v.writerid;
            },
          },
          {
            id: "writerName",
            sortable: true,
            name: "작성자",
            excel_print: (v) => {
              return v.writerName;
            },
          },
          {
            id: "addi_data2",
            sortable: true,
            name: "학습일자",
            excel_print: (v) => {
              return v.addi_data2;
            },
          },
          {
            id: "created_at",
            sortable: true,
            name: "등록일",
            excel_print: (v) => {
              return v.created_at;
            },
          },
        ],
      },
    }),
    beforeMount() {
      this.config.req_endpoint = "/articles_event/7";
      this.config.grid_parser = async (data) => {
        this.etc = data.etc;
        return {
          records: data.result,
          total: data.total,
        };
      };
    },
    watch: {
      $route(to, from) {
        if (to !== from) {
          if (!this.$route.params.board) return;
          this.config.req_endpoint = "/articles_event/7";
          this.$refs.qg.search();
        }
      },
    },
  };
  </script>
  